import { render } from "./Materiales.vue?vue&type=template&id=212796b1&scoped=true"
import script from "./Materiales.vue?vue&type=script&lang=js"
export * from "./Materiales.vue?vue&type=script&lang=js"

import "./Materiales.vue?vue&type=style&index=0&id=212796b1&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212796b1"]])

export default __exports__